export default "__VITE_ASSET__DgVIZKBD__"